import { DepositConfigTypes } from "./types/deposit-config-types";

export const DepositConfig: DepositConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
